import { render, staticRenderFns } from "./PublicQuotationPages15.vue?vue&type=template&id=21c68624&scoped=true&"
import script from "./PublicQuotationPages15.vue?vue&type=script&lang=js&"
export * from "./PublicQuotationPages15.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c68624",
  null
  
)

export default component.exports